// config.js
const config = {
    //baseURL: 'https://cross-platform-chatbot-app-5211eb66d32b.herokuapp.com/api', // heroku
    //baseURL: 'https://cool-game-meerkat.ngrok-free.app/api', // for testing
    baseURL: 'https://chatbot-backend-go-379928537900.us-east1.run.app/api', // GCP
};

export default config;